<template>
    <span>
        <b-button
            class="align-baseline"
            title="Delete"
            variant="default"
            v-b-modal="deleteModalID"
        >
            <font-awesome-icon :icon="['fas', 'trash']"></font-awesome-icon>
        </b-button>
        <modal
            :id="deleteModalID"
            title="Delete Lock"
            @shown="onModalShown"
            @ok="handleDeleteLock"
        >Lock #{{ eRentalLockLockID }} and all its access codes will be deleted from Lodgix. Are you sure?</modal>
    </span>
</template>

<script>
    import { mapGetters } from 'vuex';
    import API from '../../../../api';
    import Modal from '../../../generic/modal/modal.vue';

    export default {
        components: {
            Modal,
        },
        data() {
            return {
                lockID: 0,
                eRentalLockLockID: 0,
                deleteModalID: '',
            };
        },
        created() {
            this.lockID = this.params.data.id;
            this.eRentalLockLockID = this.params.data.lock_id;
            this.deleteModalID = `modal-delete-e-rental-lock-lock-${this.lockID}`;
        },
        methods: {
            onModalShown() {
                this.params.api.clearFocusedCell();
            },
            handleDeleteLock() {
                this.params.delete && this.params.delete(this.params.data);
            },
        },
    }
</script>